export * from './besichtigung-entfernt.interface';
